import { useCallback, useEffect, useState } from "react";

const KEY = "vms_theme";

const apply = (theme) => {
  const root = document.documentElement;
  if (theme === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
};

export const useTheme = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem(KEY) || "light");
  useEffect(() => apply(theme), [theme]);
  const toggle = useCallback(() => {
    setTheme((t) => {
      const next = t === "dark" ? "light" : "dark";
      localStorage.setItem(KEY, next);
      return next;
    });
  }, []);
  return { theme, toggle, isDark: theme === "dark" };
};

// apply on first load (before React renders)
apply(localStorage.getItem(KEY) || "light");
